import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MemberDashboard from './pages/member/MemberDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import VendorDashboard from 'pages/vendor/VendorDashboard';
import { OutletRoute, PrivateRoute, PublicRoute } from 'constants/routes';
import Connection from 'pages/connection/Connection';
import AddCertificate from 'pages/connection/components/AddCertificate';
import SetUpScript from 'pages/connection/components/SetUpScript';
import TestConnection from 'pages/connection/components/TestConnection';
import TestPayload from 'pages/connection/components/TestPayload';
import { MemberVendorProjects } from 'pages/member/VendorProjects';
import Notification from 'components/Notification';
import { NotificationProvider } from 'context/NotificationContext';
import ProtectedUserRoute from 'components/ProtectedUserRoute';
import { UserRoles } from 'store/models/User';
import './styles/Common.css';

function AppContent() {
  const { loading } = useAuth();

  // Show an empty screen while checking auth state
  if (loading) {
    return <></>;
  }

  return (
    <Routes>
      <Route element={<ProtectedRoute landingRoute={PublicRoute.Home} />}>
        <Route element={<ProtectedUserRoute userRoles={[UserRoles.ADMIN, UserRoles.VIEWER]} />}>
          <Route path={PublicRoute.Home} element={<MemberDashboard />} />
          <Route path={PrivateRoute.MemberDashboard} element={<MemberDashboard />} />
          <Route path={PrivateRoute.MemberVendorProjects} element={<MemberVendorProjects />} />
        </Route>
        <Route element={<ProtectedUserRoute userRoles={[UserRoles.VENDOR_TL, UserRoles.VENDOR_VIEWER]} />}>
          <Route path={PrivateRoute.VendorDashboard} element={<VendorDashboard />} />
          <Route path={PrivateRoute.VendorDashboardProjects} element={<VendorDashboard />} />
          <Route path={PrivateRoute.ProjectConnection} element={<Connection />}>
            <Route index element={<Navigate to={OutletRoute.AddCertificate} replace />} />
            <Route path={OutletRoute.AddCertificate} element={<AddCertificate />} />
            <Route path={OutletRoute.SetUpScript} element={<SetUpScript />} />
            <Route path={OutletRoute.TestConnection} element={<TestConnection />} />
            <Route path={OutletRoute.TestPayload} element={<TestPayload />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <AppContent />
          <Notification />
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
